import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  loading: false,
  error: null,
  data: [],
  oneData: null,
  message: ''
}

export const serviceSlice = createSlice({
  name: 'service',
  initialState,
  reducers: {
    getServices: (state) => {
      state.loading = true;
    },
    addService: (state) => {
      state.loading = true;
    },
    updateService: (state) => {
      state.loading = true;
    },
    removeService: (state) => {
      state.loading = true;
    },
    getOneService: (state) => {
      state.loading = true;
    },
    successService: (state, action) => {
      state.loading = false;
      state.data = action.payload;
    },
    successOneService: (state, action) => {
      state.loading = false;
      state.oneData = action.payload;
    },
    failedService: (state, action) => {
      state.loading = false;
      state.error = action.payload;
    }
  },
})

export const { 
  getServices, 
  addService, 
  updateService, 
  removeService, 
  getOneService, 
  successService, 
  successOneService,
  failedService 
} = serviceSlice.actions

export default serviceSlice.reducer
